import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

// Code splitting: Lazy load SharedAlbumPage
const SharedAlbumPage = lazy(() =>
  import('@/pages/SharedAlbumPage').then((m) => ({ default: m.SharedAlbumPage }))
);

export const sharedAlbumRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/share/album/$tokenOrSlug',
  component: SharedAlbumPage,
});

// Backward compatibility
export const Route = sharedAlbumRoute;
